import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AGENCE_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchAgences = createAsyncThunk('fetch-agences', async (page = 1) => {
    const response = await api.get(AGENCE_URL);
    return response.data;
});
export const createAgence = (agence, err, cb) => {
    api.post(AGENCE_URL, agence)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateAgence = (agence, err, cb) => {
    api.put(`${AGENCE_URL}/${agence.id}`, agence)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteAgence = (id, err, cb) => {
    api.delete(`${AGENCE_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


const agenceSlice = createSlice({

    name: 'agences',
    initialState: { agences: [], agencesFetchStatus: '' },

    reducers: {
        addAgence: (state, action) => {
            state.agences = [...state.agences, action.payload].sort((a,b) => sortByProp(a,b,'nom'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAgences.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.agences = [...action.payload].sort((a, b) => sortByProp(a, b, 'nom'));
                state.agencesFetchStatus = 'success';
            } else {
                console.error("fetchAgences payload is not an array:", action.payload);
                state.agences = [];
                state.agencesFetchStatus = 'error';
            }
        }).addCase(fetchAgences.pending, (state, action) => {
            state.agencesFetchStatus = 'loading';

        }).addCase(fetchAgences.rejected, (state, action) => {

            state.agencesFetchStatus = 'error';

        });
    }


});
export const { addAgence } = agenceSlice.actions;
export default agenceSlice;